// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0d7e0373","963":"e76421f9"}[chunkId] + ".chunk.js";
};